import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseCtl, ServiceLocatorService } from '@ncs/ncs-lib';


@Component({
  selector: 'app-invitation-member',
  templateUrl: './invitation-member.component.html',
  styleUrls: ['./invitation-member.component.css']
})
export class InvitationMemberComponent extends BaseCtl {
  public token: string | undefined;
  constructor(public override locator: ServiceLocatorService, public override route: ActivatedRoute) {
    super("", locator, route);
    let _self=this;
    _self.locator.config
    .getProperty('endpoint.application.users')
    .then((property: string) => {
      _self.initApiEndpoint(property);
    });
  }

  // public statusList = ['Accept', 'Reject'];

  override ngOnInit() {
    let _self = this;
    const url = window.location.href;
    const hashIndex = url.indexOf('#');
    if (hashIndex !== -1) {
      const hashParams = url.substring(hashIndex + 1);
      const paramsArray = hashParams.split('/');
      if (paramsArray.length >= 3) {
        _self.decodeBase64(paramsArray[2]);
      }
    }
  }


  public isValidToken = true;

  /**
   * Decode Base64 to and get Data 
   * @param encodedString 
   * @returns 
   */
  decodeBase64(encodedString: string): any {
    let _self = this;
    try {
      const decodedObject = JSON.parse(atob(decodeURIComponent(encodedString)));
      const currentTime = new Date().toISOString();
      if (decodedObject.expiry && currentTime > decodedObject.expiry) {
        _self.isValidToken = false;
        _self.form["message"] = 'Your Link has expired';
        console.error('Token has expired');
        alert('Token has expired');
        return;
      }
      Object.assign(_self.form.data, {
        userId: decodedObject['userId'],
        appId: decodedObject['appId'],
        orgId: decodedObject['orgId'],
        email: decodedObject['email'],
        applicationId: decodedObject['applicationId'],
        applicationRoleId: decodedObject['applicationRoleId'],
        status: "Accept"
      });

      _self.saveInvitation();
      return decodedObject;
    } catch (error) {
      console.error('Invalid token', error);
    }
  }

/**
 * Save invitation 
 */
  public saveInvitation() {
    let _self = this;
    _self.locator.config.getProperty("endpoint.application.users").then((property: string) => {
      let url = property + "/public/accept";
    _self.locator.http.post(url, _self.form['data'], (res: any, error: boolean) => {
      if (error) {
        alert("Server Error:" + error);
        return;
      }
      _self.form["error"] = !res.success;
      _self.form["message"] = res.message;
      _self.form["inputerror"] = res.result["inputerror"];

      if (res.success) {
        console.log(res.result.data);
        const accessKey = this.form.data['orgId'] + "." + this.form.data['applicationId'];
        let keySuffix = _self.locator.config.get("CONTEXT_PATH") + "-";
        localStorage.setItem(keySuffix + 'loginId', _self.form.data['email']);

        if (res.result.data === 'login') {
          _self.locator.router.navigateByUrl('/login/' + accessKey);
        }
        if (res.result.data === 'signUp') {
          _self.locator.router.navigateByUrl('/signupInvitation/' + accessKey);
        }
      }
    });
    });
  }


  gotoLogin() {
    this.forward("login");
  }
}
